import React from 'react';
import { Leaf, Zap } from 'lucide-react';
import type { ProviderTier } from '../types/providers';

interface ProviderToggleProps {
  tier: ProviderTier;
  onToggle(tier: ProviderTier): void;
  freeAvailable: boolean;
  paidAvailable: boolean;
}

export default function ProviderToggle({ tier, onToggle, freeAvailable, paidAvailable }: ProviderToggleProps) {
  return (
    <div className="flex items-center gap-1 p-0.5 rounded-lg" style={{ backgroundColor: 'var(--sage-bg)' }}>
      <ToggleBtn
        active={tier === 'free'}
        disabled={!freeAvailable}
        onClick={() => onToggle('free')}
        icon={<Leaf size={13} />}
        label="Free"
      />
      <ToggleBtn
        active={tier === 'paid'}
        disabled={!paidAvailable}
        onClick={() => onToggle('paid')}
        icon={<Zap size={13} />}
        label="Premium"
      />
    </div>
  );
}

function ToggleBtn({ active, disabled, onClick, icon, label }: {
  active: boolean; disabled: boolean; onClick: () => void; icon: React.ReactNode; label: string;
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs transition-colors disabled:opacity-30"
      style={{
        backgroundColor: active ? 'var(--sage-surface)' : 'transparent',
        color: active ? 'var(--sage-text)' : 'var(--sage-text-muted)',
      }}
    >
      {icon}
      {label}
    </button>
  );
}
